import React, { Component } from "react";
import styled from "styled-components";
import { filterByParameter } from "../dashboard.filters";
import { DealTileGrid } from '@loanbossinc/component-library';
import moment from 'moment';
import { DashboardBodyDefaultHeader } from "../DashboardBodyDefaultHeader";

const StyledWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export class AcquisitionsImageGrid extends Component {
  mapTileProps = (items) => {
    if (!items) return [];

    return items.map(item => ({
      dealStage: item.stageId
      , dealStatus: item.dealStatusId
      , name: item.name
      , imgUrl: item.imageMedium
      , dealId: item.id
      , shared: item.shared
      , description: item.targetedClosing ? `TARGET CLOSE ${moment(item.targetedClosing).format('MM/DD/YYYY')}` : undefined
      , onClick: (dealId) => this.props.redirectToDealPage(dealId)
    }));
  }

  getFiltered = () => {
    const { items, searchText } = this.props;
    const filtered = filterByParameter(items, searchText, 'name');
    return this.mapTileProps(filtered);
  }

  render() {
    const {
      title
      , onSearchChange
      , onToggleChange
      , toggleOptions
      , searchText
      , menuOptions
      , childDealsFilter
      , ...other
    } = this.props;

    return (
      <StyledWrapper>
      {childDealsFilter}
        <DashboardBodyDefaultHeader
          title={title}
          toggleOptions={toggleOptions}
          onToggleChange={onToggleChange}
          onSearchChange={onSearchChange}
          searchText={searchText}
          menuOptions={menuOptions}
        />

        <DealTileGrid
          {...other}
          items={this.getFiltered()}
        />

      </StyledWrapper>
    );
  }
}
